import { Text } from '@elements/text';
import { i18n } from '@i18n';
import { useGuestStore, useTripStore } from '@store';
import { testProps } from '@utils';

export const PolicyConfirmation = () => {
  const email = useGuestStore(state => state?.guest?.email);
  const policyNumber = useTripStore(state => state?.trip.policy?.policyNumber);

  if (!email) {
    return null;
  }

  return (
    <div className="flex flex-col gap-s16 pb-s16 border-b border-b-border-bold">
      {policyNumber ? (
        <>
          <div className="flex flex-wrap">
            <Text variant="subTitle-20/sb" {...testProps('confirmation-emailConfirmation-email')}>
              {i18n.t('confirmation.emailConfirmation.email')}
            </Text>
            <Text className="break-all" variant="subTitle-20/sb">
              {email}
            </Text>
          </div>
          <Text {...testProps('confirmation-emailConfirmation-policy')} variant="subTitle-20/sb">
            {i18n.t('confirmation.emailConfirmation.policy', { policyNumber })}
          </Text>
          <Text {...testProps('confirmation-emailConfirmation-description')} variant="body-16/r">
            {i18n.t('confirmation.emailConfirmation.description')}
          </Text>
        </>
      ) : (
        <PendingConfirmation email={email} />
      )}
    </div>
  );
};

const items = i18n.t('confirmation.pendingConfirmation.items', { returnObjects: true });

const PendingConfirmation = ({ email }: { email: string }) => {
  return (
    <>
      <div className="flex flex-wrap">
        <Text {...testProps('confirmation-pendingConfirmation-title')} variant="subTitle-20/sb">
          {i18n.t('confirmation.pendingConfirmation.title')}
        </Text>
        <Text className="break-all" variant="subTitle-20/sb">
          {email}
        </Text>
      </div>
      <ul className="list-disc ">
        {items.map((point, i) => (
          <li key={i} className="flex gap-2">
            <span className="h-1 w-1 rounded-full mt-[10px] bg-fuji-800 "></span>
            <Text
              dangerouslySetInnerHTML={{ __html: point }}
              {...testProps(`confirmation-pendingConfirmation-item-${i}`)}
            />
          </li>
        ))}
      </ul>
    </>
  );
};
